import { render, staticRenderFns } from "./BaseEtyms.vue?vue&type=template&id=0e856a8e&scoped=true&"
import script from "./BaseEtyms.vue?vue&type=script&lang=js&"
export * from "./BaseEtyms.vue?vue&type=script&lang=js&"
import style0 from "./BaseEtyms.vue?vue&type=style&index=0&id=0e856a8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e856a8e",
  null
  
)

export default component.exports